import "./env";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import ExcalidrawApp from "./App";

import "../excalidraw-app/sentry";

// on a flaky mobile connection a dynamically-imported chunk (e.g. a locale)
// can fail mid-transfer — Vite's own recovery mechanism for this, reload once
window.addEventListener("vite:preloadError", () => {
  if (!sessionStorage.getItem("vite-preload-reloaded")) {
    sessionStorage.setItem("vite-preload-reloaded", "1");
    window.location.reload();
  }
});

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <ExcalidrawApp />
  </StrictMode>,
);
